export const CONSENT_TEXT =
  'By submitting this form, you agree to receive recurring automated promotional and personalized marketing text messages from Bounty at the cell number used when signing up. Consent is not a condition of any purchase. Msg frequency varies. Msg & data rates may apply. Text STOP to cancel. Read full Creator Terms of Use & our Privacy Policy.'

export const BOUNTY_CONTENT_TYPES = [
  { name: 'TikTok', value: 'TIKTOK_VIDEO' },
  { name: 'Instagram Reel', value: 'INSTAGRAM_REEL' },
  // { name: 'Instagram Story', value: 'INSTAGRAM_STORY' },
  // { name: 'Direct Upload', value: 'DIRECT_UPLOAD_VIDEO' },
]
